
import DxCheckBox from "devextreme-vue/check-box";
import DxButton from "devextreme-vue/button";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { StoreManager } from "@/components/controls/catalogueGrid/storeManager";
import { GuidHelper } from "@/helpers/guidHelper/guidHelper";
import { defineComponent } from "vue";
import { settingsId } from "@/const/idConstant";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import CatalogueSelectControl from "@/components/controls/base/CatalogueSelectControl.vue";
import TextControl from "@/components/controls/base/TextControl.vue";
import SettingsInfoDialog from "@/components/info/SettingsInfoDialog.vue";
import EnumControl from "@/components/controls/base/EnumControl.vue";
import api from "@/services/api";

export default defineComponent({
  components: {
    DxCheckBox,
    DxButton,
    FontAwesomeIcon,
    EnumControl,
    CatalogueSelectControl,
    TextControl,
    SettingsInfoDialog,
    DxPopup,
    DxToolbarItem,
  },
  data() {
    return {
      savedModel: {},
      renderKey: null,
      loading: true,
      saving: false,
      changes: false,
      model: {},
      guidHelper: new GuidHelper(),
      storeManager: new StoreManager(),
      dataSource: null,
      isShowConnectionDialog: false,
      isConnected: false,
      closeButtonOptions: {
        text: "Закрыть",
        onClick: this.closeCheckConnectionDialog,
      },
    };
  },
  methods: {
    onShowInfo() {
      this.$refs.infoDialog.open();
    },
    onFormSubmit(e: any) {
      e.preventDefault();
      this.save();
    },
    reset() {
      this.model = { ...this.savedModel };
      this.haveChanges();
    },
    rememberSettings() {
      const temp = {
        settings: {
          showShipments: this.model.isUseShipments,
          marginUnitType: this.model.marginUnitType,
          volumeWeightDisplayType: this.model.volumeWeightDisplayType,
        },
      };
      (this as any).$store.dispatch("settings/setSettings", temp);
    },
    haveChanges() {
      if (!this.loading)
        this.changes = !(
          JSON.stringify(this.savedModel) == JSON.stringify(this.model)
        );
    },
    save() {
      this.rememberSettings();
      this.storeManager.setEditModel(this.renderKey, { ...this.model });
      this.saving = true;
      this.dataSource.update(this.model.id, { ...this.model }).then(
        () => {
          this.saving = false;
          this.savedModel = { ...this.model };
          this.haveChanges();
        },
        () => {
          this.saving = false;
          this.haveChanges();
        }
      );
    },
    async onCheckConnection() {
      try {
        await api.get(`${this.model.externalSolverUrl}/Login/CheckAuth`);
        this.isConnected = true;
      } catch {
        this.isConnected = false;
      }
      this.isShowConnectionDialog = true;
    },
    closeCheckConnectionDialog() {
      this.isShowConnectionDialog = false;
    },
  },
  created() {
    this.renderKey = this.guidHelper.getUniqueId(4);
    this.dataSource = this.storeManager.getStandartGridCrudStore(
      "Settings",
      this.renderKey
    );
    this.dataSource.getEdit(settingsId).then((model) => {
      this.savedModel = { ...model };
      this.reset();
      this.loading = false;
      this.haveChanges();
    });
  },
  computed: {
    isShowServerSettings() {
      return this.$can("view", "Administration");
    },
    isShowSettings() {
      return this.$can("view", "Settings");
    },
  },
});
